import { MasonryGrid } from '~/components/ui/MasonryGrid';
import { QuestionV2 } from '~/lib/discussions/types';
import QuestionCard from './card/QuestionCard';
import QuestionSkeleton from './card/QuestionSkeleton';

function QuestionList({
  questions,
  partnersIds = [],
  mutateComment,
}: Readonly<{
  questions: Array<QuestionV2>;
  partnersIds?: Array<number>;
  mutateComment?: () => void;
}>): JSX.Element {
  if (!questions || questions.length === 0) {
    return (
      <MasonryGrid desktopColumnGap={24} desktopRowGap={24}>
        {Array.from({ length: 5 }).map((_, index) => (
          <QuestionSkeleton key={index} />
        ))}
      </MasonryGrid>
    );
  }

  return (
    <MasonryGrid desktopColumnGap={24} desktopRowGap={24}>
      {questions.map((question) => (
        <QuestionCard
          key={question.id}
          question={question}
          partnersIds={partnersIds}
          mutateComment={mutateComment}
        />
      ))}
    </MasonryGrid>
  );
}

export default QuestionList;
